import React, { useState, useRef, useEffect } from 'react';
import './AccountDropdown.css';
interface AccountDropdownProps {
  onLogout: () => void;
  onDeleteAccount: () => void;
  isLoggingOut?: boolean;
}
const AccountDropdown: React.FC<AccountDropdownProps> = ({ onLogout, onDeleteAccount, isLoggingOut = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  // Cerrar dropdown al hacer click fuera
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);
  const handleLogout = () => {
    setIsOpen(false);
    onLogout();
  };
  const handleDeleteAccount = () => {
    setIsOpen(false);
    onDeleteAccount();
  };
  return (
    <div className="account-dropdown-container" ref={dropdownRef}>
      <button
        type="button"
        className="account-dropdown-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Opciones de cuenta"
        disabled={isLoggingOut}
      >
        <svg 
          width="20" 
          height="20" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
      </button>
      {isOpen && (
        <div className="account-dropdown-menu">
          <button
            type="button"
            className="account-dropdown-item"
            onClick={handleLogout}
            disabled={isLoggingOut}
          >
            <svg 
              width="18" 
              height="18" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            <span>{isLoggingOut ? 'Cerrando...' : 'Cerrar Sesión'}</span>
          </button>
          <button
            type="button"
            className="account-dropdown-item account-dropdown-item-danger"
            onClick={handleDeleteAccount}
            disabled={isLoggingOut}
          >
            <svg 
              width="18" 
              height="18" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              <line x1="10" y1="11" x2="10" y2="17"></line>
              <line x1="14" y1="11" x2="14" y2="17"></line>
            </svg>
            <span>Eliminar Cuenta</span>
          </button>
        </div>
      )}
    </div>
  );
};
export default AccountDropdown;